import { render, staticRenderFns } from "./VacationArchive.vue?vue&type=template&id=25fb7650&scoped=true&"
import script from "./VacationArchive.vue?vue&type=script&lang=js&"
export * from "./VacationArchive.vue?vue&type=script&lang=js&"
import style0 from "./VacationArchive.vue?vue&type=style&index=0&id=25fb7650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb7650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VRow,VSelect,VSpacer})
